import { FeatureFlagChannel } from '@tableau/microview-communication-service/lib/src/channelDefinitions/FeatureFlagChannelDefinitions';

import { FeatureFlags } from '../../ts/FeatureFlags';


export function startListening(): () => void {
    const featureFlagChannel = new FeatureFlagChannel();
    const unsubscribeFeatureFlagChannel =  featureFlagChannel.listen((request) => {
        const featureFlags = FeatureFlags as {[featureFlag: string]: boolean};
        const featureFlagState = featureFlags[request.featureFlag];
        if(featureFlagState === undefined)
           throw new Error(request.featureFlag + ' is an invalid FeatureFlag');

        return { featureFlagState: featureFlagState};
    });

    return () => {
        unsubscribeFeatureFlagChannel();
    };
}
